/**
 *
 * @name app.module.NavMenuDirective
 * @copyright 2015 Empower Retirement
 * @require angular
 * @description Directive responsible for the Site Header
 *
 */
import * as _ from "lodash";
import accountSwitchModalTemplate from "../header/accountSwitch/AccountSwitchModalTemplate";
import saveChangesTemplate from "../header/saveChanges/saveChangesTemplate";
import navMenuViewTemplate from "./NavMenuViewTemplate";
import saveChangesController from "../header/saveChanges/saveChangesController";
import AccountSwitchController from "../header/accountSwitch/AccountSwitchController";

var NavMenuDirective = function (
    $modal,
    $window,
    $location,
    accountService,
    MenuService,
    MobileMenuService,
    LegacyService,
    PreventNavigationService,
    samlTokenService,
    $state,
    $rootScope,
    MenuItemModalService
) {
    return {
        restrict: "E",
        scope: true,
        template: navMenuViewTemplate,
        link: function (scope, element, attrs) {
            _.extend(
                scope,
                _.mapValues(attrs, function (v, k) {
                    return scope.$eval(v);
                })
            );

            scope.getMenuNavigation = MenuService.getMenuNavigation;
            scope.getActiveMenuItem = MenuService.getActiveMenuItem;
            scope.getActiveSubMenuItem = MenuService.getActiveSubMenuItem;
            scope.getDetailTitle = MenuService.getDetailTitle;
            scope.getUrlForAcctSubMenuItem = MenuService.getUrlForAcctSubMenuItem;
            scope.menuItemModalServiceClick = MenuItemModalService.click;
            scope.getUrlForNavItem = MenuService.getUrlForNavItem;
            scope.setActiveGroupAccount = accountService.setActiveGroupAccount;
            scope.retrieveMenuNavDetails = MenuService.retrieveMenuNavDetails;
            scope.getBankAccountsList = accountService.getBankAccountsList;
            scope.accountMenuList = [];

            scope.activeGroupAccount = accountService.getActiveGroupAccount();
            accountService.getSelectedAccount().then(function (account) {
                scope.selectedAccount = account;
            });
            scope.isAccountSelected = accountService.isAccountSelected;
            accountService
                .setAccounts()
                .then(function () {
                    var contextData = {};
                    scope.allAccounts = accountService.getAccounts();

                    var nonCurrentContextNums = {};
                    var nonCurrentcontenxtPlanName = {};

                    angular.forEach(scope.allAccounts, function (item) {
                        var contextKey = item.individualId + "-" + item.accuCode;
                        if (
                            item.currentContext &&
                            scope.allAccounts.length > 1 &&
                            scope.activeGroupAccount.individualId &&
                            item.individualId &&
                            scope.activeGroupAccount.individualId != item.individualId
                        ) {
                            item.currentContext = false;
                        }
                        if (item.currentContext) {
                            var displayPlanName = item.name;
                            if (displayPlanName && displayPlanName.length > 80) {
                                item.contextPlanName = displayPlanName.slice(0, 80) + "\u2026";
                            }
                            contextData[contextKey] = item.contextPlanName;
                        } else {
                            //concatenating plannames for other context plans
                            if (contextData[contextKey]) {
                                if (nonCurrentContextNums[contextKey] < 3) {
                                    var concatenatedPlanName =
                                        contextData[contextKey] +
                                        ", " +
                                        (checkCharCount(item.name, 26)
                                            ? item.name.slice(0, 26) + "\u2026"
                                            : item.name);
                                    contextData[contextKey] = concatenatedPlanName;
                                    nonCurrentContextNums[contextKey]++;
                                }
                            } else {
                                contextData[contextKey] = checkCharCount(item.name, 26)
                                    ? item.name.slice(0, 26) + "\u2026"
                                    : item.name;
                                nonCurrentContextNums[contextKey] = 1;
                                nonCurrentcontenxtPlanName[contextKey] = item.name;
                            }
                        }
                    });

                    angular.forEach(scope.allAccounts, function (item) {
                        if (item.currentContext) {
                            item.contextPlanName =
                                item.name.length > 80
                                    ? item.name.slice(0, 80) + "\u2026"
                                    : item.name;
                        } else {
                            var contextKey = item.individualId + "-" + item.accuCode;
                            if (
                                nonCurrentContextNums[contextKey] &&
                                nonCurrentContextNums[contextKey] == 1
                            ) {
                                contextData[contextKey] = checkCharCount(
                                    nonCurrentcontenxtPlanName[contextKey],
                                    80
                                )
                                    ? nonCurrentcontenxtPlanName[contextKey].slice(0, 80) + "\u2026"
                                    : nonCurrentcontenxtPlanName[contextKey];
                            }
                            var planName = contextData[contextKey];
                            item.contextPlanName = planName;
                            delete contextData[contextKey];
                        }
                    });
                })
                .then(function () {
                    // set flag for Total Rewards link
                    samlTokenService.showTotalRewardsPromise().then(
                        function (response) {
                            var TRData = {};
                            if (response.data && response.data.status) {
                                TRData.data = response.data.data;
                                TRData.status = response.data.status;
                            } else {
                                TRData.data = response.data;
                                TRData.status = response.status;
                            }

                            if (
                                TRData.status === "SUCCESSFUL" &&
                                !TRData.status.error &&
                                TRData.data === true
                            ) {
                                scope.displayTotalRewards = TRData.data;
                            } else {
                                scope.displayTotalRwards = false;
                            }
                        },
                        function () {
                            // error calling showTotalRewards
                            scope.displayTotalRewards = false;
                        }
                    );
                });

            scope.legacyActiveGroupAccount = LegacyService.getLegacyActiveGroupAccount();
            scope.getAccountDetailsLoaded = MenuService.getAccountDetailsLoaded;
            scope.currentAccount = null;

            scope.activeMenuTier = 0;
            var activeTierState = 1;

            scope.toggleMenu = function (event) {
                MobileMenuService.toggle();
                sessionStorage.setItem("currentMenuState", 0);
            };

            scope.closeMenu = function () {
                MobileMenuService.toggle(false);
                scope.accountMenuIsActive = false;
            };

            scope.mobileHeaderClass = function () {
                var result = [MobileMenuService.get() ? "navbar-toggled" : ""];
                result.push("navbar-tier-" + scope.activeMenuTier);

                return result.join(" ");
            };

            scope.setActiveMenuTier = function (tierNumber) {
                scope.activeMenuTier = tierNumber;
            };
            scope.getActiveMenuTier = function () {
                return scope.activeMenuTier;
            };

            scope.$watch("scope.activeMenuTier > 0", function () {
                scope.mobileHeaderClass();
            });

            scope.toggleAccountMenu = function (e) {
                if ($window.innerWidth < 960) {
                    e.preventDefault();
                    scope.setActiveMenuTier(scope.accountMenuIsActive ? 1 : 0);
                    scope.accountMenuIsActive = !scope.accountMenuIsActive;
                }
            };

            scope.isMobileBrowser = function () {
                return $window.innerWidth < 960;
            };

            scope.isEnrollmentPlan = function (url) {
                return url.indexOf("/enroll/") !== -1;
            };

            scope.isEnrollmentPage = function () {
                return $window.location.href.indexOf("/participant/enroll/") !== -1;
            };

            scope.redirectEnrollmentPage = function (enrollURL) {
                if ($window.location.href.indexOf(enrollURL) == -1) {
                    $window.location.href = LegacyService.getCurrentDomain() + enrollURL;
                    $window.location.reload();
                }
            };

            scope.getUrlToEnroll = function (enrollURL) {
                return LegacyService.getCurrentDomain() + enrollURL;
            };

            scope.activateAccountDropDown = function (e) {
                MenuService.retrieveAccountMenuDetails().then(function (data) {
                    var tempList = [];
                    var contextData = {};
                    scope.allMenuAccounts = [];
                    var nonCurrentContextNums = {};
                    var nonCurrentcontenxtPlanName = {};
                    if (data.length > 1) {
                        data = accountService.sortPlans(data);
                        // data.map(val =>scope.allMenuAccounts.push(Object.assign({}, val)));
                        _.map(data, function (item) {
                            scope.allMenuAccounts.push(item);
                        });
                        angular.forEach(data, function (item, index) {
                            var contextKey = item.individualId + "-" + item.accuCode;
                            if (
                                item.currentContext &&
                                data.length > 1 &&
                                scope.activeGroupAccount.individualId &&
                                item.individualId &&
                                scope.activeGroupAccount.individualId != item.individualId
                            ) {
                                item.currentContext = false;
                            }
                            if (item.currentContext) {
                                var displayPlanName = item.planName;
                                if (displayPlanName && displayPlanName.length > 80) {
                                    item.planName = displayPlanName.slice(0, 80) + "\u2026";
                                }
                                contextData[contextKey] = item.planName;
                            } else {
                                if (contextData[contextKey]) {
                                    if (nonCurrentContextNums[contextKey] < 3) {
                                        var concatenatedPlanName =
                                            contextData[contextKey] +
                                            ", " +
                                            (checkCharCount(item.planName, 26)
                                                ? item.planName.slice(0, 26) + "\u2026"
                                                : item.planName);
                                        contextData[contextKey] = concatenatedPlanName;
                                        nonCurrentContextNums[contextKey]++;
                                    }
                                } else {
                                    contextData[contextKey] = checkCharCount(item.planName, 26)
                                        ? item.planName.slice(0, 26) + "\u2026"
                                        : item.planName;
                                    nonCurrentContextNums[contextKey] = 1;
                                    nonCurrentcontenxtPlanName[contextKey] = item.planName;
                                }
                            }
                        });

                        angular.forEach(data, function (item, index) {
                            item.plName = item.planName;
                            if (item.currentContext) {
                                // item.plName  =  item.planName;
                                tempList.push(item);
                            } else {
                                var contextKey = item.individualId + "-" + item.accuCode;
                                if (
                                    nonCurrentContextNums[contextKey] &&
                                    nonCurrentContextNums[contextKey] == 1
                                ) {
                                    contextData[contextKey] = checkCharCount(
                                        nonCurrentcontenxtPlanName[contextKey],
                                        80
                                    )
                                        ? nonCurrentcontenxtPlanName[contextKey].slice(0, 80) +
                                          "\u2026"
                                        : nonCurrentcontenxtPlanName[contextKey];
                                }
                                var planName = contextData[contextKey];
                                var copyItem = item;
                                if (planName) {
                                    copyItem.plName = planName;
                                    tempList.push(copyItem);
                                    delete contextData[contextKey];
                                }
                            }
                        });
                        scope.accountMenuList = tempList;
                    } else {
                        scope.accountMenuList = data;
                    }
                });
            };

            function checkCharCount(str, len) {
                if (str != null && str != "" && str != "undefined" && str.length > len) {
                    return true;
                }
                return false;
            }

            scope.toggleDesktopAccountMenu = function (event) {
                var accountMenuObj = document.getElementById("AccountMenu");
                if (!this.isMobileBrowser() && accountMenuObj) {
                    accountMenuObj.classList.toggle("open");
                    event.stopPropagation();
                }
            };

            $window.addEventListener("click", function () {
                closeAccountMenu();
            });

            $window.addEventListener("blur", function () {
                closeAccountMenu();
            });

            function closeAccountMenu() {
                var accountMenuObj = document.getElementById("AccountMenu");
                if (accountMenuObj && accountMenuObj.classList.contains("open")) {
                    accountMenuObj.classList.remove("open");
                }
            }

            scope.getAccountCount = function () {
                return accountMenuList.length;
            };

            scope.skipMainNavigation = function () {
                document.getElementById("mainBody").setAttribute("tabindex", -1);
                document.getElementById("mainBody").addEventListener("blur", function () {
                    this.removeAttribute("tabindex");
                });
                document.getElementById("mainBody").addEventListener("focusout", function () {
                    this.removeAttribute("tabindex");
                });
                document.getElementById("mainBody").focus();
            };

            scope.isParticipantApp = function () {
                return $window.location.href.indexOf("/participant/accounts") > -1;
            };
            scope.openDNPModal = function () {
                if (this.isParticipantApp()) {
                    $state.go("standalone.savingsAndBill");
                } else {
                    $window.location.href = "/participant/accounts/" + "#/savingsAndBill";
                }
            };

            scope.closeAccountNavMenu = function () {
                scope.setActiveMenuTier(0);
                scope.accountMenuIsActive = false;
            };

            scope.guidanceClickHandler = function (event) {
                event.preventDefault();
                if (PreventNavigationService.isPreventUrl()) {
                    PreventNavigationService.preventNavigation(event, "INVESTING", scope);
                } else {
                    if (scope.accountMenuIsActive) {
                        scope.closeAccountNavMenu();
                        return;
                    }
                    scope.advice.onGuidanceClick(true);
                }
            };

            scope.openWellnessPage = function (event) {
                event.preventDefault();
                if (scope.accountMenuIsActive) {
                    scope.closeAccountNavMenu();
                    return;
                    scope.profileClicked();
                }
            };
            scope.logoutClickHandler = function (event) {
                // event.preventDefault;
                if (scope.accountMenuIsActive) {
                    scope.closeAccountNavMenu();
                    return;
                }
                scope.logout(event);
            };

            scope.homeClickHandler = function (event, path) {
                event.preventDefault();
                if (PreventNavigationService.isPreventUrl()) {
                    PreventNavigationService.preventNavigation(event, "LIAT_HOME", scope);
                } else {
                    if (scope.accountMenuIsActive) {
                        scope.closeAccountNavMenu();
                        return;
                    }
                    var url = $location.url();
                    var navItem = event.target.dataset.navValue;

                    var transition = true;
                    var statesToCheck = [
                        // we don't want to re-route and refresh the page if we are already at LIAT
                        "/retirement-income",
                        "/health-care-costs",
                        "/how-do-i-compare",
                        "/plan-balances"
                    ];

                    var re;
                    var leading = /^.*/;
                    var noTrailingSlash = /[^/]*$/;

                    for (var i = 0; i < statesToCheck.length; i++) {
                        re = new RegExp(leading.source + statesToCheck[i] + noTrailingSlash.source);
                        if (re.test(url)) {
                            transition = false;
                            break;
                        }
                    }

                    if (transition) {
                        //DEFC-19724 - user should be prompted to 'stay' if in NQ enrollment.
                        //a simple window.location prevent the state change logic.
                        if (
                            $state.current &&
                            $state.current.name &&
                            $state.current.name.indexOf("nqEnrollment") > -1
                        ) {
                            $state.go("landing.liat");
                        } else {
                            $window.location.href =
                                $location.protocol() +
                                "://" +
                                $location.host() +
                                scope.retirementIncomeUrl;
                        }
                    }
                }
            };

            scope.wellnessIsActive = function () {
                const hash = $window.location.hash;
                return hash.indexOf("wellness") > -1;
            };
            scope.guidanceIsActive = function () {
                const hash = $window.location.hash;
                return hash.indexOf("guidance") > -1;
            };

            scope.accountsIsActive = function () {
                const pathname = $window.location.pathname;
                const hash = $window.location.hash;
                return (
                    pathname.indexOf("participant/accounts") > -1 && hash.indexOf("#/account") === 0
                );
            };
            scope.homeIsActive = function () {
                const pathname = $window.location.pathname;
                const hash = $window.location.hash;

                return scope.txnAccess.liatEnabled
                    ? pathname.indexOf("participant/home") > -1
                    : hash.indexOf("overview") > -1;
            };

            scope.prevent = function (e, type) {
                if (PreventNavigationService.isPreventUrl()) {
                    PreventNavigationService.preventNavigation(e, type, scope);
                }
            };

            scope.switchPlan = function (account) {
                //PART-29873 warning modal on incomplete enrollment page
                if (PreventNavigationService.isPreventUrl()) {
                    scope.nextVal = "SWITCH_PLAN";
                    scope.newAccount = account;

                    $modal.open({
                        template: saveChangesTemplate,
                        controller: saveChangesController,
                        controllerAs: "enrollCtrl",
                        size: "md",
                        windowClass: "auto-increase-wrapper",
                        scope: scope,
                        rootScope: $rootScope,
                        window: $window
                    });
                } else {
                    var individualId = account.individualId;
                    var reqParams = {
                        individualId: account.individualId,
                        dbName: account.dbName,
                        accuCode: account.accuCode
                    };
                    angular.forEach(scope.allMenuAccounts, function (acct) {
                        if (
                            scope.activeGroupAccount.groupId === acct.groupId &&
                            scope.activeGroupAccount.individualId === acct.individualId
                        ) {
                            scope.currentAccount = acct;
                        }
                    });
                    if (
                        individualId !== scope.currentAccount.individualId ||
                        (individualId === scope.currentAccount.individualId &&
                            account.accuCode !== scope.currentAccount.accuCode)
                    ) {
                        accountService.primaryPlanByIndId(reqParams).then(function (response) {
                            angular.forEach(scope.allMenuAccounts, function (acct) {
                                if (
                                    acct.groupId === response.gaId &&
                                    acct.individualId === response.indId
                                ) {
                                    scope.clickedAccount = acct;
                                }
                            });
                            scope.defaultGroupId = response.defaultGroupId;
                            scope.defaultIndId = response.defaultIndId;
                            var modalInstance = $modal.open({
                                template: accountSwitchModalTemplate,
                                controller: AccountSwitchController,
                                controllerAs: "switchPlanCtrl",
                                size: "md",
                                windowClass: "auto-increase-wrapper",
                                scope: scope
                            });
                        });
                    }
                }
            };
        }
    };
};

NavMenuDirective.$inject = [
    "$modal",
    "$window",
    "$location",
    "accountService",
    "MenuService",
    "MobileMenuService",
    "LegacyService",
    "PreventNavigationService",
    "samlTokenService",
    "$state",
    "$q",
    "$injector",
    "$rootScope",
    "MenuItemModalService",
    NavMenuDirective
];
export default NavMenuDirective;
